<template>
    <div class="admin-reseller-admin mt-page">

        <crud-table :title="$i18n.gt('LABEL_MANAGE_RESELLER_ADMINS')"
                    item-table="reseller-admin"
                    item-name="Admin"
                    :new-item="newItem"
                    :filters="filters"
                    :display-fields="displayFields"
                    :edit-fields="editFields">
        </crud-table>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import * as _ from 'lodash'

/**
 * Page to manage reseller admins
 */
export default Vue.extend({
    name: 'AdminResellerAdmin',
    data() {
        return {
            newItem: null, // can't add new items (would need to figure out how to edit userEmail)
            displayFields: [
                {key: 'userEmail', sortable: true},
                {
                    key: 'reseller.name', sortable: true, label: 'Reseller',
                    get: (item) => {
                        return item.reseller ? item.reseller.name : ''
                    }
                },
            ],
            resellerOptions: [],
        }
    },
    computed: {
        filters() {
            return {
                userEmail: {
                    field: 'userEmail',
                    type: 'string',
                    value: null,
                    label: 'User Email'
                },
                'reseller.id': {
                    field: 'reseller.id',
                    type: 'select',
                    value: null,
                    label: 'Reseller',
                    options: this.resellerOptions
                },
            }
        },
        editFields() {
            return [
                // TODO: make userEmail editable (how?)
                {key: 'reseller_id', type: 'select', label: 'Reseller', options: this.resellerOptions},
            ]
        },
    },
    mounted() {
        this.$api.getAllItems(this, 'reseller')
            .then((items) => {
                this.resellerOptions = _.concat(
                    [{value: null, text: ''}],
                    _.map(items, (reseller) => {
                        return {value: reseller.id, text: reseller.name}
                    })
                )
            })
    }
})

</script>
